import React from "react";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CONTACT, SECTORS } from "@/data/media";
import { Seo } from "@/components/Seo";
import { MapPin, Mail } from "lucide-react";

export default function Contact() {
  const { t } = useLang();

  return (
    <div data-testid="contact-page">
      <Seo page="contact" />
      <PageHero overline={t.contact.overline} title={t.contact.title} image={SECTORS.uffici} intro={t.contact.intro} />

      <section className="py-16 md:py-24 bg-cream">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="bg-ink text-white p-8 md:p-12" data-testid="contact-info">
              <h3 className="font-serif-display text-2xl md:text-3xl mb-8">{t.contact.infoTitle}</h3>
              <ul className="space-y-8">
                <li className="flex gap-4">
                  <MapPin className="w-5 h-5 text-brass shrink-0 mt-1" />
                  <div>
                    <div className="overline mb-1">{t.contact.addressLabel}</div>
                    <div className="text-white/80 text-sm md:text-base leading-relaxed">{CONTACT.address}</div>
                  </div>
                </li>
                <li className="flex gap-4">
                  <Mail className="w-5 h-5 text-brass shrink-0 mt-1" />
                  <div>
                    <div className="overline mb-1">Email</div>
                    <a href={`mailto:${CONTACT.emailInfo}`} className="block text-white/80 text-sm md:text-base hover:text-brass transition-colors" data-testid="contact-info-email">{CONTACT.emailInfo}</a>
                    <a href={`mailto:${CONTACT.emailProject}`} className="block text-white/80 text-sm md:text-base hover:text-brass transition-colors" data-testid="contact-project-email">{CONTACT.emailProject}</a>
                  </div>
                </li>
              </ul>
              <div className="brass-line w-full mt-10 opacity-40" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
